<template>
  <div>
    <b-tabs content-class="ctc-statement-tab-content" class="statement-tabs">
      <b-tab :title="modalHeadTitle" lazy>
        <b-form @submit.stop.prevent="onSubmit">

<!--          <div class="card mb-3" style="max-width: 140px">-->
<!--            <div class="card-header p-2">-->
<!--              Selected Year-->
<!--            </div>-->
<!--            <div class="card-body p-2">-->
<!--              {{ year }}-->
<!--            </div>-->
<!--          </div>-->

          <div class="ctc-mapping-table table-responsive">
            <table class="table table-hover mb-0 custom-report-table">
              <thead class="text-white custom-thead">
              <tr>
                <th></th>
                <th>Monthly</th>
                <th>Yearly</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(head, index) in data" :key="index">
                <input type="hidden" v-model="head.id">
                <input type="hidden" v-model="head.employee_cost_id">
                <td class="align-middle">
                  {{ head.name }}
                  <span class="ctc-freq-badge text-capitalize ml-1" v-if="head.payment_frequency">
                    {{ head.payment_frequency.replace('_', '-') }}
                  </span>
                </td>
                <td>
                  <b-form-group :id="`monthly-${head.id}-group`" label="" :label-for="`monthly-${head.id}`"
                                class="m-0">
                    <b-form-input :id="`monthly-${head.id}`"
                                  :name="`monthly-${head.id}`"
                                  v-model="head.monthly"
                                  :disabled="!$acl || $acl['cost-to-company'] < 2"
                                  v-validate="{ decimal: 2, max: 30 }"
                                  :state="validateState(`monthly-${head.id}`)"
                                  :aria-describedby="`monthly-${head.id}-feedback`"
                                  data-vv-as="Monthly Cost"></b-form-input>
                    <b-form-invalid-feedback :id="`monthly-${head.id}-feedback`">
                      {{ veeErrors.first(`monthly-${head.id}`) }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </td>
                <td>
                  <b-form-group :id="`yearly-${head.id}-group`" label="" :label-for="`yearly-${head.id}`"
                                class="m-0">
                    <b-form-input :id="`yearly-${head.id}`"
                                  :name="`yearly-${head.id}`"
                                  v-model="head.yearly"
                                  :disabled="!$acl || $acl['cost-to-company'] < 2"
                                  v-validate="{ decimal: 2, max: 30 }"
                                  :state="validateState(`yearly-${head.id}`)"
                                  :aria-describedby="`yearly-${head.id}-feedback`"
                                  data-vv-as="Yearly Cost"></b-form-input>
                    <b-form-invalid-feedback :id="`yearly-${head.id}-feedback`">
                      {{ veeErrors.first(`yearly-${head.id}`) }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="ctc-mapping-submit-row">
            <b-button type="submit" class="btn-teal-solid ctc-mapping-submit" :disabled="isSubmitDisabled || !$acl || $acl['cost-to-company'] < 2">Submit</b-button>
          </div>
        </b-form>
      </b-tab>
      <b-tab v-if="parseInt(type) === 1" title="Annual Overhead Cost" lazy>
        <b-form @submit.stop.prevent="onOverheadSubmit">
<!--          <div class="card mb-3" style="max-width: 140px">-->
<!--            <div class="card-header p-2">-->
<!--              Selected Year-->
<!--            </div>-->
<!--            <div class="card-body p-2">-->
<!--              {{ year }}-->
<!--            </div>-->
<!--          </div>-->
          

          <div class="ctc-mapping-table table-responsive">
            <table class="table table-hover mb-0 custom-report-table">
              <thead class="text-white custom-thead">
              <tr>
                <th>Overhead Monthly</th>
                <th>Overhead Yearly</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <input type="hidden" v-model="overheadData.id">
                <td>
                  <b-form-group id="overhead-monthly" label="" label-for="overhead-monthly" class="m-0">
                    <b-form-input id="overhead-monthly"
                                  name="overhead-monthly"
                                  v-model="overheadData.monthly"
                                  :disabled="!$acl || $acl['cost-to-company'] < 2"
                                  v-validate="{ decimal: 2, max: 30 }"
                                  :state="validateState('overhead-monthly')" aria-describedby="overhead-monthly"
                                  data-vv-as="Monthly Cost"></b-form-input>
                    <b-form-invalid-feedback id="overhead-monthly-feedback">
                      {{ veeErrors.first("overhead-monthly") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </td>
                <td>
                  <b-form-group id="overhead-yearly" label="" label-for="overhead-yearly" class="m-0">
                    <b-form-input id="overhead-yearly"
                                  name="overhead-yearly"
                                  v-model="overheadData.yearly"
                                  :disabled="!$acl || $acl['cost-to-company'] < 2"
                                  v-validate="{ decimal: 2, max: 30 }"
                                  :state="validateState('overhead-yearly')" aria-describedby="overhead-yearly"
                                  data-vv-as="Yearly Cost"></b-form-input>
                    <b-form-invalid-feedback id="overhead-yearly-feedback">
                      {{ veeErrors.first("overhead-yearly") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--                <b-row>-->
          <!--                  <input type="hidden" v-model="overheadData.id">-->
          <!--                  <b-col>-->
          <!--                    <b-form-group id="overhead-monthly" label="" label-for="overhead-monthly">-->
          <!--                      <b-form-input id="overhead-monthly"-->
          <!--                                    name="overhead-monthly"-->
          <!--                                    v-model="overheadData.monthly"-->
          <!--                                    :state="validateState('overhead-monthly')" aria-describedby="overhead-monthly"-->
          <!--                                    data-vv-as="Monthly Cost"></b-form-input>-->
          <!--                      <b-form-invalid-feedback id="overhead-monthly-feedback">-->
          <!--                        {{ veeErrors.first("overhead-monthly") }}-->
          <!--                      </b-form-invalid-feedback>-->
          <!--                    </b-form-group>-->
          <!--                  </b-col>-->
          <!--                  <b-col>-->
          <!--                    <b-form-group id="overhead-yearly" label="" label-for="overhead-yearly">-->
          <!--                      <b-form-input id="overhead-yearly"-->
          <!--                                    name="overhead-yearly"-->
          <!--                                    v-model="overheadData.yearly"-->
          <!--                                    :state="validateState('overhead-yearly')" aria-describedby="overhead-yearly"-->
          <!--                                    data-vv-as="Monthly Cost"></b-form-input>-->
          <!--                      <b-form-invalid-feedback id="overhead-yearly-feedback">-->
          <!--                        {{ veeErrors.first("overhead-yearly") }}-->
          <!--                      </b-form-invalid-feedback>-->
          <!--                    </b-form-group>-->
          <!--                  </b-col>-->
          <!--                </b-row>-->
          <div class="ctc-mapping-submit-row">
            <b-button type="submit" class="btn-teal-solid ctc-mapping-submit" :disabled="!$acl || $acl['cost-to-company'] < 2">Submit</b-button>
          </div>
        </b-form>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import ctcOverlay from '../js/ctcOverlay';

export default {
  mixins: [ctcOverlay],
  props: [
    'employeeID', 'year', 'type'
  ],
  watch: {
    showOverlay(newVal) {
      this.ctcOverlay(newVal);
    }
  },
  mounted() {
    // this.permission = this.$acl['leave-type'];
  },
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Name', name: 'name', sort: true},
      {label: 'Status', name: 'status'},
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });


    let modalHeadTitle = parseInt(this.type) === 1 ? 'Annual Year Statement' : 'Compensatory Statement';

    return {
      blankMsg: 'Fetching data..',

      showOverlay: false,
      data: [],
      overheadData: {},

      status: [
        {value: "0", text: "Disabled"},
        {value: "1", text: "Enable"},
      ],


      years: [
        {text: '2019', value: '2019'},
        {text: '2020', value: '2020'},
        {text: '2021', value: '2021'},
        {text: '2022', value: '2022'},
        {text: '2023', value: '2023'},
        {text: '2024', value: '2024'},
        {text: '2025', value: '2025'},
      ],

      modalHeadTitle: modalHeadTitle,
    }
  },
  methods: {
    exportEmployeeData() {
      this.$bvModal.show("bv-modal-employee-list");
    },
    resetForm() {
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    getCostMapping() {
      if (!this.checkNet()) return false;

      this.data = [];
      let currentObj = this;

      let formData = {
        employee_id: this.employeeID,
        year: this.year,
        type: this.type,
      }

      axios.post('/cost-to-company/manual-ctc-mapping/get-employee-cost-mapping', formData).then((response) => {
        response.data.fieldData.forEach((item, i) => {
          this.data.push({
            id: item.mapping_id,
            employee_cost_id: item.employee_cost_id,
            name: item.name,
            employee_id: currentObj.employeeID,
            monthly: item.monthly,
            yearly: item.yearly,
            payment_frequency: item.payment_frequency || 'monthly'
          });
        });

        if (response.data.overheadData !== null) {
          currentObj.overheadData = response.data.overheadData;
        }
      }).catch((error) => {
        currentObj.serverError(error)
      })
    },
    onSubmit(e) {
      if (!this.$acl || this.$acl['cost-to-company'] < 2) {
        this.$bvToast.toast('You are not authorized to save mappings.', { title: 'Error', variant: 'danger', solid: true });
        return;
      }
      // if (!this.checkNet()) return false;
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.showOverlay = true;

        e.preventDefault();
        let currentObj = this;

        /*let fieldValue = 0;
        this.data.forEach((value) => {
          if (!isNaN(parseInt(value.monthly)) && parseInt(value.monthly) > 0) {
            fieldValue = 1;
          }
          if (!isNaN(parseInt(value.yearly)) && parseInt(value.yearly) > 0) {
            fieldValue = 1;
          }
        })

        if (fieldValue === 0) {
          let msg = "Please add valid value on at least one field."
          this.$bvToast.toast(msg, {
            title: `Error!`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right'
          });

          return;
        }*/

        let url = '/cost-to-company/manual-ctc-mapping/cost-mapping';
        let formData = {
          employee_id: this.employeeID,
          year: this.year,
          main: this.data,
          type: this.type,
        }
        axios.post(url, formData)
            .then(function (response) {
              currentObj.showOverlay = false;
              this.resetForm();
              this.$emit("close-cost-mapping-modal", "")
            }.bind(this))
            .catch(function (error) {
              currentObj.showOverlay = false;
              currentObj.serverError(error);
            });
      });
    },
    onOverheadSubmit(e) {
      if (!this.$acl || this.$acl['cost-to-company'] < 2) {
        this.$bvToast.toast('You are not authorized to save overhead mappings.', { title: 'Error', variant: 'danger', solid: true });
        return;
      }
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        e.preventDefault();
        let currentObj = this;

        let url = '/cost-to-company/manual-ctc-mapping/cost-overhead-mapping';

        let fieldValue = 0;
        if (!isNaN(parseInt(this.overheadData.monthly)) && !isNaN(parseInt(this.overheadData.yearly))) {
          if (parseInt(this.overheadData.monthly) > 0 && parseInt(this.overheadData.yearly) > 0) {
            fieldValue = 1;
          }
        }

        if (fieldValue === 0) {
          let msg = "Please add valid value for both monthly and yearly for Overhead Cost."
          this.$bvToast.toast(msg, {
            title: `Error!`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right'
          });

          return;
        }

        // Raised only once the payload is known to be valid: raising it before the
        // guard left the overlay up for good on every rejected submit.
        this.showOverlay = true;

        let overheadFromData = {
          year: this.year,
          main: this.overheadData,
          valu: 'asss',
        }

        axios.post(url, overheadFromData)
            .then(function (response) {
              currentObj.showOverlay = false;
              this.$emit("close-cost-mapping-modal", "")
            }.bind(this))
            .catch(function (error) {
              currentObj.showOverlay = false;
              currentObj.serverError(error);
            });
      });
    },
    serverError(error) {
      if (error.response && error.response.data) {
        let errorMessage = error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right'
        });
      } else {
        console.error(error);
        this.$bvToast.toast('An unexpected error occurred.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right'
        });
      }
    }
  },
  computed: {
    isSubmitDisabled() {
      if (!this.data || this.data.length === 0) {
        return true;
      }
      return this.data.every(head => {
        return (head.monthly === null || head.monthly === undefined || head.monthly === '') &&
               (head.yearly === null || head.yearly === undefined || head.yearly === '');
      });
    }
  },
  created: function () {
    this.getCostMapping();
  },
}
</script>

<style scoped>
/* Cost-mapping dialog body, drawn from the `manual_annual_reports` Figma frame
   (exported at 2x, so every measurement below is half the pixel value there).
   The modal shell around it — width, 32px title, mint header rule, close cross —
   lives in resources/sass/_ctc.scss under .ctc-mapping-modal, because
   BootstrapVue teleports modals to document.body and scoped CSS cannot reach the
   header. */

/* Tabs are card tabs, not the filled pills this modal used before: the active
   statement sits in a white box outlined in mint, and its bottom edge continues
   as the rule that runs the full width of the body. b-tabs renders the nav
   itself, so the scope attribute never reaches .nav-link — hence ::v-deep. */
.statement-tabs ::v-deep .nav-tabs {
    border-bottom: 1px solid #BDDBCE;
    flex-wrap: nowrap;
}

.statement-tabs ::v-deep .nav-item {
    /* Pulls the active tab's own bottom border onto the nav's rule so the mint
       line reads as unbroken across the tab rather than opening up around it. */
    margin-bottom: -1px;
    margin-right: 4px;
}

.statement-tabs ::v-deep .nav-link {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 10px 12px !important;
    border: 1px solid transparent !important;
    border-radius: 4px 4px 0 0 !important;
    background-color: transparent !important;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.02em;
    color: #7A8C93 !important;
    box-shadow: none !important;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.statement-tabs ::v-deep .nav-link:hover {
    color: #01524B !important;
    text-decoration: none !important;
}

.statement-tabs ::v-deep .nav-link.active,
.statement-tabs ::v-deep .nav-link.active:hover {
    background-color: #FFFFFF !important;
    border-color: #BDDBCE !important;
    color: #01524B !important;
}

.statement-tabs ::v-deep .nav-link:focus {
    outline: none !important;
    box-shadow: none !important;
}

.statement-tabs ::v-deep .ctc-statement-tab-content {
    margin-top: 30px;
}

/* The statement table is drawn straight onto the modal — square corners, no card
   frame, every cell outlined instead. That is why it does not use the shared
   .table-container-custom wrapper; this one only has to keep a wide table
   scrolling. */
.ctc-mapping-table {
    background-color: #fff;
}

/* `display: block` + `width: 100%` undo the global .table-responsive override in
   responsive.scss (`display: table; overflow-x: visible`), which is imported
   later: as a table box the wrapper sizes to its content and a wide table spills
   out of the modal body instead of scrolling. */
.ctc-mapping-table.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

/* `collapse` (the shared .custom-report-table asks for `separate`, which the
   rounded CTC list tables need) so the 1px cell outlines merge into single
   hairlines instead of doubling up. `fixed` gives the equal columns the frame
   shows, for both the three-column statement and the two-column overhead table. */
.ctc-mapping-table .custom-report-table {
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 0;
}

.ctc-mapping-table .custom-thead th,
.ctc-mapping-table .custom-thead th + th {
    height: 44px;
    padding: 10px !important;
    border: 1px solid #126D66 !important;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 14px;
    letter-spacing: -0.02em;
    text-align: center;
    vertical-align: middle;
    color: #FFFFFF;
}

/* 68px rows: a 40px input with 14px of air above and below, inside the 10px
   gutter the frame gives every cell. */
.ctc-mapping-table .custom-report-table td {
    padding: 14px 10px;
    border: 1px solid #E8E8E8;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.4;
    letter-spacing: -0.02em;
    color: #34444C;
    vertical-align: middle;
}

/* The cost inputs fill their cell — the `w-50` these form-groups used to carry
   left half of every column as dead space. */
.ctc-mapping-table .custom-report-table td .form-group {
    width: 100%;
    margin-bottom: 0;
}

/* Mint-outlined boxes with the value centred under its column title. */
.ctc-mapping-table .form-control {
    height: 40px;
    padding: 0 10px;
    border: 1px solid #BDDBCE;
    border-radius: 6px;
    background-color: #FFFFFF;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    letter-spacing: -0.02em;
    color: #34444C;
    text-align: center;
    box-shadow: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ctc-mapping-table .form-control:focus {
    border-color: #025147;
    box-shadow: 0 0 0 3px rgba(2, 81, 71, 0.1);
    outline: none;
}

.ctc-mapping-table .form-control:disabled,
.ctc-mapping-table .form-control[readonly] {
    background-color: #F8FAFC;
    color: #7A8C93;
}

/* Restated because the mint border above is scoped — so it carries an extra
   attribute selector — and would otherwise outrank Bootstrap's validation
   colours and swallow the red outline on a rejected amount. */
.ctc-mapping-table .form-control.is-invalid {
    border-color: #dc3545;
}

.ctc-mapping-table .form-control.is-valid {
    border-color: #28a745;
}

.ctc-mapping-table ::v-deep .invalid-feedback {
    font-size: 12px;
    text-align: center;
}

/* Payment frequency reads as a quiet tag beside the head name rather than
   Bootstrap's grey badge, which fought the 16px label next to it. */
.ctc-freq-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    background-color: #EAF5F0;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0;
    color: #01524B;
    vertical-align: middle;
}

/* Submit is centred under the table and larger than the standard CTC action
   button: 195 x 48 with 8px corners. .btn-teal-solid sets its height, radius and
   font-size with !important, so the overrides have to match. */
.ctc-mapping-submit-row {
    margin-top: 30px;
    text-align: center;
}

.ctc-mapping-submit.btn-teal-solid {
    width: 195px;
    height: 48px !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    letter-spacing: -0.02em;
}
</style>

